import CollapsableCard from './CollapsableCard';

export default CollapsableCard;
